import { Trans, useTranslation } from 'react-i18next'
import { ARCHITECTURE_CARDS } from './constants'

export function ArchitectureContent() {
  const { t } = useTranslation()
  const bold = <span className="font-semibold" />

  return (
    <div className="bg-card px-6 py-4">
      <div className="grid grid-cols-1 grid-rows-[1fr] gap-[14px] sm:grid-cols-3">
        {ARCHITECTURE_CARDS.map(card => (
          <div
            key={card.titleKey}
            className="flex flex-col rounded-2xl p-4"
            style={{ backgroundColor: '#FFFAEF80' }}
          >
            <h3 className="mb-2 text-[15px] font-bold" style={{ color: '#171721' }}>
              {t(card.titleKey)}
            </h3>
            <p className="text-[13px] leading-relaxed font-normal" style={{ color: '#171721' }}>
              {card.useTrans ? (
                <Trans i18nKey={card.descriptionKey} components={{ 1: bold }} />
              ) : (
                t(card.descriptionKey)
              )}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-4 mb-4">
        <h2 className="mb-4 text-base font-bold" style={{ color: '#B11739' }}>
          {t('discover.sections.architectureSectionTitle')}
        </h2>
        <div
          className="text-foreground space-y-3 text-sm leading-relaxed font-normal"
          style={{ color: '#171721' }}
        >
          <h3 className="text-foreground text-sm font-bold">
            {t('discover.sections.architectureBody.infrastructureSubtitle')}
          </h3>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.infrastructureP1"
              components={{ 1: bold }}
            />
          </p>
          <p>{t('discover.sections.architectureBody.infrastructureP2')}</p>
          <ul className="list-inside list-disc space-y-1 pl-2">
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.infrastructureBullet1"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.infrastructureBullet2"
                components={{ 1: bold }}
              />
            </li>
          </ul>
          <h3 className="text-foreground mt-4 text-sm font-bold">
            {t('discover.sections.architectureBody.ingenierieSubtitle')}
          </h3>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.ingenierieP1"
              components={{ 1: bold }}
            />
          </p>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.ingenierieP2"
              components={{ 1: bold }}
            />
          </p>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.ingenierieP3"
              components={{ 1: bold }}
            />
          </p>
          <h3 className="text-foreground mt-4 text-sm font-bold">
            {t('discover.sections.architectureBody.transparenceSubtitle')}
          </h3>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.transparenceP1"
              components={{ 1: bold }}
            />
          </p>
          <h3 className="text-foreground mt-4 text-sm font-bold">
            {t('discover.sections.architectureBody.fiabiliteSubtitle')}
          </h3>
          <p>{t('discover.sections.architectureBody.fiabiliteIntro')}</p>
          <ul className="list-inside list-disc space-y-1 pl-2">
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet1"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet2"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet3"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet4"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet5"
                components={{ 1: bold }}
              />
            </li>
            <li>
              <Trans
                i18nKey="discover.sections.architectureBody.fiabiliteBullet6"
                components={{ 1: bold }}
              />
            </li>
          </ul>
          <h3 className="text-foreground mt-4 text-sm font-bold">
            {t('discover.sections.architectureBody.supervisionSubtitle')}
          </h3>
          <p>
            <Trans
              i18nKey="discover.sections.architectureBody.supervisionIntro"
              components={{ 1: bold }}
            />
          </p>
          <ul className="list-inside list-disc space-y-1 pl-2">
            <li>{t('discover.sections.architectureBody.supervisionBullet1')}</li>
            <li>{t('discover.sections.architectureBody.supervisionBullet2')}</li>
            <li>{t('discover.sections.architectureBody.supervisionBullet3')}</li>
            <li>{t('discover.sections.architectureBody.supervisionBullet4')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
